import React from "react";
import DocumentList from "./DocumentList";

const Provisjonsbulletin: React.FC = () => {
    return <DocumentList documentType="PROVISJONSBULLETIN" />;
};

export default Provisjonsbulletin;
